/**
 * English Pythagorean theorem prompts (ADR 0109 §4). The check in the key is
 * written with "=" and "not": the not-equal sign is not in WinAnsi (ADR 0070).
 * A length is followed by a no-break space and "cm" so a line never starts with
 * "cm" alone.
 */
const CM = ` cm`;

export const pythagoreanPrompts = {
    hypotenuse: () => `Find the hypotenuse.`,
    missingSide: () => `Find the missing side.`,
    rightTriangle: (a: number, b: number, c: number) =>
        `Can sides of ${a}${CM}, ${b}${CM} and ${c}${CM} make a right triangle?`,
    /** The key for a yes: the two squares and the square they make. */
    yes: (aSquared: number, bSquared: number, cSquared: number) =>
        `Yes: ${aSquared} + ${bSquared} = ${cSquared}`,
    /** The key for a no: the two squares, their sum, and the square it is not. */
    no: (aSquared: number, bSquared: number, sum: number, cSquared: number) =>
        `No: ${aSquared} + ${bSquared} = ${sum}, not ${cSquared}`,
};
